import { render, staticRenderFns } from "./SkinnedTournamentOverviewCard.vue?vue&type=template&id=11c568a4&scoped=true"
import script from "./SkinnedTournamentOverviewCard.vue?vue&type=script&lang=js"
export * from "./SkinnedTournamentOverviewCard.vue?vue&type=script&lang=js"
import style0 from "./SkinnedTournamentOverviewCard.vue?vue&type=style&index=0&id=11c568a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c568a4",
  null
  
)

export default component.exports